import { jsx as _jsx } from "react/jsx-runtime";
import { default as UiLoading } from "@atlaskit/spinner";
export default (function (props) {
    return _jsx(UiLoading, { delay: props.delay || 250, size: props.size || 24 });
});
//# sourceMappingURL=index.js.map